<template>
    <div class="ratebox">
        <div style="position:relative;">
            <span class="rating_image" :class="imageClass" :style="imagePosition"></span>
            <input type="range" class="rating" step="1" min="1" :max="maxValue"
                   v-model.number="selected" />
        </div>
    </div>
</template>

<script>
	export default {
		name: "RateBox",
		props: {
			choices: {
				type: Object,
				required: true
			},
			name: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				selected: 1,
				thumbSize: 6
			};
		},
		computed: {
			imageClass: function () {
				return 'rating-image'; // rating-image--' + this.selected;
			},
			imagePosition: function () {

				let step = ((100 - this.thumbSize) / (this.maxValue - 1)),
					scale = .8 + (0.6 * (this.selected / this.maxValue));

				return {
					backgroundImage: 'url(' + require('@/assets/images/barometer/' + this.ratingImage() + '.png') + ')',
					transform: 'scale(' + scale + ')',
					left: (this.thumbSize / 2 + (step * (this.selected - 1))) + '%'
				};
			},
			maxValue: function () {
				if ( this.choices.hasOwnProperty('to') ) {
					return this.choices.to;
				}
				else {
					return this.choices.length;
				}
			}

		},
		methods: {
			ratingImage: function () {

				if ( this.choices.hasOwnProperty('to') ) {
					let groupSize = (this.choices.to - this.choices.from) / this.choices.steps;

					return Math.ceil(this.selected / groupSize);
				}
				else {

					return this.selected - 1;
				}
				return 2;
			}
		},
		mounted() {
			this.selected = Math.ceil( this.maxValue / 2 );
			this.thumbSize = 24 / (this.$el.querySelector('[type="range"]').offsetWidth / 100); // thumbWidth : 24px
			this.$el.style.setProperty('--input-width', (this.$el.offsetWidth) + 'px');

		},
		watch: {
			selected: function ( val ) {

				this.$emit('change',val);
			}
		}
	};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/subparts/RateBox/RateBox.vue